<div class="body-container">
  <div class="page-main">
    <div class="page-container">
      <form *ngIf="isFormReady" [formGroup]="form" novalidate class="form-wrapper">
        <div class="form-wrapper">
          <div class="form-content">
            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Dunning Cycles</h1>
              </div>
              <div class="form-section-container">
                <div class="form-section-head">
                  <div class="form-row">
                    <p class="typo caption fw300 semi-condensed">Payment Declined Dunning Cycle - This cycle starts whenever a payment is attempted and fails.</p>
                  </div>
                </div>
                <div class="form-section-body">

                  <section class="panel inner-panel">
                    <div class="panel-wrapper">
                      <div formArrayName="dunningCycle" class="panel-collection">
                        <div [formGroupName]="i" *ngFor="let cycle of dunningCycle.controls let i = index"
                          class="panel-inner">
                          <div class="panel-head">
                            <div class="panel-title">
                              <label matLine class="typo subheading-1 semi-condensed fw400">Cycle #{{ i + 1 }}</label>
                            </div>
                            <div *ngIf="i !== 0" class="panel-action">
                              <button mat-stroked-button (click)="removeNotificationEmail(i)" color="primary"
                                disableRipple="true"
                                class="custom-mat-button button-remove button-remove-block">Remove</button>
                            </div>
                          </div>
                          <div class="panel-body">
                            <div class="form-block">
                              <div class="form-row">
                                <mat-form-field class="custom-mat-form-field size size1of1">
                                  <input matInput type="number" required placeholder="Days" formControlName="cycleFrec" >
                                </mat-form-field>
                              </div>
                              <p class="typo caption fw300 semi-condensed">{{collectionOfCounters[i]}} days after the initial payment attempt fails.</p>
                            </div>
                          </div>
                        </div>

                        <div class="form-row row-add-panel">
                          <button mat-stroked-button (click)="newNotificationEmail()" color="primary"
                            disableRipple="true" class="custom-mat-button button-new-block">Add Retry Cycle</button>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div class="form-section">
              <div class="form-section-side">
                <h1 class="label-title">Dunning Ending</h1>
              </div>
              <div class="form-section-container">
                <div class="form-section-head">
                  <div class="form-row">
                    <p class="typo caption fw300 semi-condensed">End of Payment Declined Dunning Cycle - What should happen to the rate plan when the last dunning cycle failed?</p>
                  </div>
                </div>
                <div class="form-section-body">
                  <div class="form-row">
                    <mat-form-field class="custom-mat-form-field size size1of1">
                      <mat-label>Rate plan</mat-label>
                      <mat-select formControlName="dunningCycleAction" required [(value)]="selectedRatePlanOption"
                        (selectionChange)="onChangeRatePlanOptions($event.value)" class="custom-mat-select">
                        <mat-option *ngFor="let item of collectionOfRatePlanOptions" [value]="item.value"
                          class="custom-mat-option">{{ item.label }}</mat-option>
                      </mat-select>
                      <mat-error><error-messages [control]="form.get('dunningCycleAction')"></error-messages></mat-error>
                    </mat-form-field>
                  </div>
                  <section *ngIf="form.controls['dunningCycleAction'].value === 'stop'" class="message message-row">
                    <div class="message-wrapper attention">
                      <div class="message-inner">
                        <mat-icon svgIcon="ico-help-faq" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                        <p class="label-message-detail">Notice that you will stop sending emails for payments.</p>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav class="post-form">
          <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted" color="primary"
            class="custom-mat-button-primary rounded typo uppercase size size1of1">Save Config</button>
        </nav>
      </form>
      <!-- skeleton form-sections -->
      <div *ngIf="!isFormReady">
        <skeleton-loader-form [top]=true [numberOfInputs]=4></skeleton-loader-form>
        <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
      </div>
    </div>
  </div>
</div>
